import { render, staticRenderFns } from "./aboutStore.vue?vue&type=template&id=220fa55b&"
import script from "./aboutStore.vue?vue&type=script&lang=js&"
export * from "./aboutStore.vue?vue&type=script&lang=js&"
import style0 from "./aboutStore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports